'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const waitUntil=require('../../../dist-es6/testUtils/waitUntil');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const ScrollDurationMs=262;let

SidebarScrollingService=function(){
function SidebarScrollingService($document,$timeout){_classCallCheck(this,SidebarScrollingService);
this._$document=$document;
this._$timeout=$timeout;
this._preventAutoScroll=!1;

this.reset();
}SidebarScrollingService.prototype.






reset=function reset(){
if(_.exists(this.__scrollerWrapperElement)){
this.__scrollerWrapperElement.stop(!0,!0);
}
this.__scrollerWrapperElement=void 0;
this._isScrolling=!1;
this._lastItem=void 0;
};SidebarScrollingService.prototype.

immediatelyJumpToLastPosition=function immediatelyJumpToLastPosition(){var _this=this;
if(!_.exists(this._lastPosition)){
return;
}
waitUntil(function(){return _this._preventAutoScroll===!1}).
then(function(){
_this._preventAutoScroll=!0;
fastdom.mutate(function(){
_this._scrollerWrapper.stop(!0,!1);
_this._scrollerWrapper.scrollTop(_this._lastPosition);
_this._$timeout(function(){
_this._preventAutoScroll=!1;
},50);
});
});
};SidebarScrollingService.prototype.









updateLastPosition=function updateLastPosition(newScrollTop){
this._lastPosition=newScrollTop;
};SidebarScrollingService.prototype.

scrollToSelection=function(){var ref=_asyncToGenerator(function*(item,itemToElementMap){var _this2=this;
if(this._preventAutoScroll===!0||
this._isScrolling===!0||
_.exists(this._lastItem)&&this._lastItem===item){
return;
}

const itemButtonElement=itemToElementMap.get(item);
if(!_.exists(itemButtonElement)){
this._lastItem=void 0;
return;
}

fastdom.mutate(function(){
try{
const newScrollTop=_tryGetNewScrollTop(itemButtonElement,_this2._scrollerWrapper);
if(!_.exists(newScrollTop)){
return;
}
if(_this2._lastPosition===newScrollTop){
return;
}

_this2._lastItem=item;
_this2._isScrolling=!0;
_this2._scrollerWrapper.animate({scrollTop:newScrollTop},ScrollDurationMs);
_this2._lastPosition=newScrollTop;
}catch(err){
console.error(err);
}finally{
_this2._isScrolling=!1;
}
});
});function scrollToSelection(item,itemToElementMap){return ref.apply(this,arguments)}return scrollToSelection}();_createClass(SidebarScrollingService,[{key:'_scrollerWrapper',get:function(){return this.__scrollerWrapperElement||(this.__scrollerWrapperElement=angular.element(this._$document).find('#sidebar.pulsar-scrollbar'))}},{key:'preventAutoScroll',get:function(){return this._preventAutoScroll},set:function(preventAutoScroll){this._preventAutoScroll=preventAutoScroll}}]);return SidebarScrollingService}();


const _getTopAndInnerHeightFor=function(element){
return{
top:element.offset().top,
innerHeight:element.innerHeight()};

};


function _tryGetNewScrollTop(element,scrollerWrapper){
let elementInfo;
if(!element.is(':visible')){
element.css({visibility:'hidden'}).show();
elementInfo=_getTopAndInnerHeightFor(element);
element.css({visibility:'',display:''});
}else{
elementInfo=_getTopAndInnerHeightFor(element);
}

const visibleAreaStart=scrollerWrapper.scrollTop();
const visibleAreaEnd=visibleAreaStart+scrollerWrapper.innerHeight();
const innerScrollerVerticalOffset=scrollerWrapper.find('> .scrollable-content').offset().top;

const elementDistanceFromTopOfScrollableArea=elementInfo.top-innerScrollerVerticalOffset;

const startsBeforeVisibleArea=elementDistanceFromTopOfScrollableArea<visibleAreaStart;
const endsAfterVisibleArea=elementDistanceFromTopOfScrollableArea+elementInfo.innerHeight>visibleAreaEnd;

if(!startsBeforeVisibleArea&&!endsAfterVisibleArea){
return;
}

const scrollTop=startsBeforeVisibleArea?
Math.max(elementDistanceFromTopOfScrollableArea-elementInfo.innerHeight*0.5,0):
visibleAreaStart+(elementDistanceFromTopOfScrollableArea+elementInfo.innerHeight-visibleAreaEnd)+elementInfo.innerHeight*0.55;

if(scrollTop===visibleAreaStart){
return;
}

return scrollTop;
}

module.exports=SidebarScrollingService;
//# sourceMappingURL=sidebarScrollingService.js.map
